
/** Verilen tarihin saatini 00:00:00.000 yaparak yeni bir Date döner. */
export function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Verilen tarihin saatini 23:59:59.999 yaparak yeni bir Date döner. */
export function endOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

/** Tarihe gün ekler veya çıkarır (negatif days ile), yeni Date döner. */
export function addDays(date: Date, days: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

/** İki tarih arasındaki gün farkını döner; aynı gün için 1 döner. */
export function diffDays(start: Date, end: Date): number {
  const msPerDay = 1000 * 60 * 60 * 24;
  const startMs = startOfDay(start).getTime();
  const endMs = startOfDay(end).getTime();
  return Math.round(Math.abs(endMs - startMs) / msPerDay) + 1;
}

/** Tarihi "GG.AA.YYYY" formatında döner. */
export function formatDateTR(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

/** Tarihi HTML date input için "YYYY-AA-GG" formatında döner. */
export function formatDateISO(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Verilen periyotla aynı uzunlukta bir önceki periyodu döner. */
export function getPreviousPeriod(start: Date, end: Date): { start: Date; end: Date } {
  const days = diffDays(start, end);
  const prevEnd = addDays(startOfDay(start), -1);
  const prevStart = addDays(prevEnd, -(days - 1));
  return { start: startOfDay(prevStart), end: endOfDay(prevEnd) };
}

/** Tarih veya ISO string'in verilen aralık içinde olup olmadığını döner (dahil). */
export function isDateInRange(date: Date | string, start: Date, end: Date): boolean {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.getTime() >= startOfDay(start).getTime() && d.getTime() <= endOfDay(end).getTime();
}

/**
 * Verilen tarihin ait olduğu MESAİ GÜNÜ anahtarını verir ("YYYY-MM-DD").
 * Mesai başlangıç saatinden (startHour) önce yapılan işlemler bir önceki güne sayılır.
 */
export function getBusinessDayKey(date: Date | string, startHour: number = 8): string {
  const d = typeof date === 'string' ? new Date(date) : new Date(date);
  const bd = new Date(d);
  if (d.getHours() < startHour) bd.setDate(bd.getDate() - 1);
  const y = bd.getFullYear();
  const m = String(bd.getMonth() + 1).padStart(2, '0');
  const day = String(bd.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
